import { Observable } from 'rxjs';
import { IPageHeader } from '../../interfaces/pageHeader.interface';
import { INavigationEvent } from './aumico.layout.action';

export interface IAumicoCoreLayoutProvider {
    getActiveSubNavigation(): void;
    getActivePage(): void;
    dispatchUpdateHideFooterOption(hideOptions: boolean): void;
    getHideFooterOption$(): Observable<boolean>;
    dispatchSetLayoutHidden(isHidden: boolean): void;
    getIsLayoutHidden$(): Observable<boolean>;

    resetLayout(): void;

    /**
     *
     * @deprecated use dispatchNavigateToRoute instead
     */
    dispatchShouldNavigateToRoute(event: INavigationEvent): void;
    dispatchNavigateToRoute(event: INavigationEvent): void;
    triggerOnSubNavigation(event: INavigationEvent): void;

    getPageHeader$(): Observable<IPageHeader>;
    dispatchChangePageHeader(pageHeader: IPageHeader): void;
}
